var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getCurrentInstance, inject, onMounted, onBeforeUnmount, nextTick, computed, } from 'vue';
export function keyInProvides(key) {
    const instance = getCurrentInstance();
    return key in instance.provides;
}
export function useParent(key) {
    if (!keyInProvides(key)) {
        return {
            index: null,
            parentProvider: null,
            bindParent: null,
        };
    }
    const provider = inject(key);
    const { childInstances, collect, clear } = provider, parentProvider = __rest(provider, ["childInstances", "collect", "clear"]);
    const childInstance = getCurrentInstance();
    const index = computed(() => childInstances.indexOf(childInstance));
    const bindParent = (childProvider) => {
        onMounted(() => {
            nextTick().then(() => {
                collect(childInstance, childProvider);
            });
        });
        onBeforeUnmount(() => {
            nextTick().then(() => {
                clear(childInstance, childProvider);
            });
        });
    };
    return {
        index,
        parentProvider,
        bindParent,
    };
}
